import { useCartContext } from '../provider/cart/CartContext';

export const checkGiftCardPurchase = () => {
  const { cartData: { cart } } = useCartContext();
  return {
    isGiftCardPurchase: cart?.lineItems?.length === 1 && cart?.lineItems?.[0].type === 'gift-card',
  };
};
